export interface WalletCategory {
	id: string;
	label: string;
	isDefault: boolean;
	order: number;
}

export const DEFAULT_WALLET_CATEGORIES: WalletCategory[] = [
	{ id: 'academic', label: 'Academic', isDefault: true, order: 0 },
	{ id: 'personal', label: 'Personal', isDefault: true, order: 1 },
	{ id: 'sports', label: 'Interests', isDefault: true, order: 2 },
	{ id: 'awards', label: 'Awards', isDefault: true, order: 3 }
];
